// components/dashboard/DriverActivity.js
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { driverActivityList } from "../../services/Networkcall";
// import { set } from "react-datepicker/dist/dist/date_utils.js";
import { errorAlert } from "../common/Alert";
import { Loader } from "../common/Loader";
import CustomPagination from "../common/CustomPagination";


const DriverActivity = ({activityKey=""}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1,limit:5, totalPages: 1,  totalRecords: 1 })

  const fetchDriverActivity = async () => {
    setLoading(true);
    if(activityKey === "driver"){ setPagination((prev) => ({ ...prev,limit: 10 })); }
    try {
      const limit = activityKey === "driver" ? 10 : 5;
      const res = await driverActivityList({ page: pagination.page, limit });
      if (res?.success) {
        setData(res.data);
        setPagination((pre) => ({ ...pre, totalPages: res?.totalPages, totalRecords: res?.totalRecords }))
      } else {
        errorAlert({ message: res?.message || "Failed to fetch driver activity" });
      }
    } catch (error) {
      console.error("Error fetching driver activity:", error);
      errorAlert({ message: "Failed to fetch driver activity" });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDriverActivity();
  }, [pagination?.page,activityKey]);
  
  const pageHandler = (page) => {
    setPagination((pre) => ({ ...pre, page: page }));
  }


  return (
    <div className="driver-card">
      <Loader show={loading} />

      {/* Header */}
      <div className="driver-header">
        <h5>Driver Activity</h5>
      </div>

      {/* Table */}
      <Table className="driver-table align-middle">
        <thead>
          <tr>
            <th>DRIVER</th>
            <th>TOTAL BOOKINGS</th>
            <th>COMPLETED</th>
            {/* <th>CANCELLED</th> */}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((item, i) => (
              <tr key={i}>

              {/* Driver */}
              <td>
                <div className="driver-cell">
                  <img
                    src={item?.driverProfileImage || "assets/images/placeholder.png"}
                    alt=""
                    className="avatar"
                  />
                  <div>
                    <div className="name">{item?.driverName}</div>
                    <div className="phone">{item?.driverPhoneNumber}</div>
                  </div>
                </div>
              </td>

              {/* Total */}
              <td>{item?.totalBookings || 0}</td>

              {/* Completed */}
              <td className="text-success fw-semibold">
                {item?.completedBookings || 0}
              </td>

              {/* Cancelled */}
              {/* <td className="text-danger fw-semibold">
                {item?.cancelledBookings || 0}
              </td> */}

               
            </tr>
          ))) : (
            <tr>
              <td colSpan="4" className="text-center mx-auto py-4">
                No driver activity found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Footer */}
      <CustomPagination
        pagination={pagination}
        pageHandler={pageHandler}
      />

    </div>
  );
};

export default DriverActivity;